// Single source of truth for mapping a fit verdict to a color level.
// Both the numeric aggregate score and the textual recommendation resolve to
// the same green/yellow/red vocabulary so the badge and the pill stay in sync.
export const FIT_COLOR = {
  GREEN: "green",
  YELLOW: "yellow",
  RED: "red",
};

export function scoreColor(score) {
  if (score > 0.7) return FIT_COLOR.GREEN;
  if (score > 0.5) return FIT_COLOR.YELLOW;
  return FIT_COLOR.RED;
}

export function recommendationColor(recommendation) {
  switch (recommendation) {
    case "Move forward":
      return FIT_COLOR.GREEN;
    case "Do not move forward":
      return FIT_COLOR.RED;
    case "Needs more evaluation":
      return FIT_COLOR.YELLOW;
    default:
      return FIT_COLOR.YELLOW;
  }
}
